/**
 * Tenant actions
 */
export enum TenantActionEnum {
	/**
	 * Set tenant status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set tenant status to on notice payment
	 */
	PUT_ON_NOTICE_PAYMENT = 'put_on_notice_payment',

	/**
	 * Set tenant status to on hold
	 */
	PUT_ON_HOLD = 'put_on_hold',

	/**
	 * Set tenant status to inactive
	 */
	DEACTIVATE = 'deactivate',

	/**
	 * Set tenant status to awaiting termination
	 */
	TERMINATE = 'terminate',
}
